import { styled as muiStyled } from '@mui/material/styles'
import { ButtonBase, Dialog, Paper } from '@mui/material'

export const AssessmentImagesGalleryStyledDialog = muiStyled(Dialog)(({ theme }) => `
  .MuiDialog-container {
    align-items: flex-start!important;
  }
`)

export const AssessmentImagesGalleryDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
  max-width: 96vw!important;
  max-height: 300px!important;
  width: 100%!important;
  margin: 0px!important;
  height: 100%!important;
`,
)

export const PsychAssessmentImageGalleryImage = muiStyled('img')(
  ({ theme }) => `
  width: 100%!important;
  height: 100%!important;
  object-fit: contain!important;
`,
)

export const PsychAssessmentImageGalleryContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex!important;
  flex-wrap: wrap!important;
  justify-content: center!important;
  gap: 10px!important;
`,
)

export const PsychAssessmentImageGalleryImageContainer = muiStyled(ButtonBase)(
  ({ theme }) => `
  width: 200px!important;
  height: 200px!important;
`,
)
